var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBkgGiallo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1480 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_64",
    x1: 3453.44,
    y1: 1163.9,
    x2: 2714.54,
    y2: 461.4,
    gradientTransform: "translate(4027.78 1505.8) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8cd46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#f8cd46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d89d3b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_77",
    x1: 4185.26,
    y1: 1685.16,
    x2: 3209.61,
    y2: 800.52,
    gradientTransform: "translate(4027.78 1505.8) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8cd46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#e5b440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d89d3b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_109",
    x1: 4109.48,
    y1: 1843.77,
    x2: 2911.98,
    y2: 757.98,
    gradientTransform: "translate(4027.78 1505.8) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8cd46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#e5b440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d89d3b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_120",
    x1: 3452.19,
    y1: 1721.51,
    x2: 2311.25,
    y2: 371.47,
    gradientTransform: "translate(4027.78 1505.8) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8cd46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#f2c644"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#e5b440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#dca43c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d89d3b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_168",
    x1: 3463.41,
    y1: 1526.03,
    x2: 2337.1,
    y2: 426.48,
    gradientTransform: "translate(4027.78 1505.8) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8cd46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#e5b440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d89d3b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_136",
    x1: 3319.36,
    y1: 1923.15,
    x2: 2502.52,
    y2: 958.01,
    gradientTransform: "translate(4027.78 1505.8) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8cd46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#f2c644"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#e5b440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#dca43c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d89d3b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_142",
    x1: 4242.61,
    y1: 1700.08,
    x2: 3176.83,
    y2: 903.48,
    gradientTransform: "translate(4027.78 1505.8) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8cd46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#e5b440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d89d3b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_149",
    x1: 4957.51,
    y1: 1358.43,
    x2: 2966.29,
    y2: 1057.19,
    gradientTransform: "translate(4027.78 1505.8) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8cd46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#e5b440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d89d3b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_156",
    x1: 3164.28,
    y1: 700.83,
    x2: 3892.52,
    y2: 1512.82,
    gradientTransform: "translate(4027.78 1505.8) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8cd46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#e5b440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d89d3b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_174",
    x1: 4350.85,
    y1: 1644.9,
    x2: 2739.04,
    y2: 933.38,
    gradientTransform: "translate(4027.78 1505.8) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8cd46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#e5b440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d89d3b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_168-2",
    x1: 3289.45,
    y1: 990.29,
    x2: 3875.64,
    y2: 1469.9,
    xlinkHref: "#Sfumatura_senza_nome_168"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_174-2",
    x1: 4016.22,
    y1: 1594.44,
    x2: 3097.62,
    y2: 980.83,
    xlinkHref: "#Sfumatura_senza_nome_174"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_181",
    x1: 4177.36,
    y1: 2118.75,
    x2: 3472.56,
    y2: 1130.57,
    gradientTransform: "translate(4027.78 1505.8) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8cd46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#e5b440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d89d3b"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Sfumatura_senza_nome_187",
    cx: 3249.26,
    cy: 1110.28,
    fx: 3249.26,
    fy: 1110.28,
    r: 1062.84,
    gradientTransform: "translate(4027.78 1416.07) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8cd46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#e5b440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d89d3b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_184",
    x1: 4106.12,
    y1: 1972.52,
    x2: 3353.29,
    y2: 1081.71,
    gradientTransform: "translate(4027.78 1505.8) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8cd46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#f2c644"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#e5b440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#dca43c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d89d3b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_203",
    x1: 3087.26,
    y1: 1620.62,
    x2: 2620.23,
    y2: 1039.27,
    gradientTransform: "translate(4027.78 1505.8) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8cd46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#e5b440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d89d3b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_211",
    x1: 3327.59,
    y1: 892.93,
    x2: 3857.14,
    y2: 1509.53,
    gradientTransform: "translate(4027.78 1505.8) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8cd46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#e5b440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d89d3b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_220",
    x1: 3434.07,
    y1: 1100.44,
    x2: 3619.55,
    y2: 1285.91,
    gradientTransform: "translate(4027.78 1505.8) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8cd46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#e5b440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#e1ae3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#d89e3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d89d3b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_228",
    x1: 1284.41,
    y1: 724.23,
    x2: 1580.78,
    y2: 876.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d89d3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d89d3b",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_7",
    x1: 741.77,
    y1: 1030.6,
    x2: 741.77,
    y2: 719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5b440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#e5b440",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#e5b440",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#e5b440",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#e5b440",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#e5b440",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#e5b440",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#e5b440",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#e5b440",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#e5b440",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5b440",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_5",
    x1: 372.36,
    y1: -730.65,
    x2: 372.36,
    y2: -1253,
    gradientTransform: "translate(0 -759.15) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5b440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#e5b440",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#e5b440",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#e5b440",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#e5b440",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#e5b440",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#e5b440",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#e5b440",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#e5b440",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5b440",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_25",
    x1: 0,
    y1: 500,
    x2: 1480,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8cd46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#f8cd46",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#f8cd46",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8cd46"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Livello_1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -7.12,
    y: -32.41,
    width: 1496.9,
    height: 1066.15,
    style: {
      fill: "url(#Sfumatura_senza_nome_64)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1188.97-32.41H-6.37v1063.98h361.52c101.81-53.37,201.71-119.49,296.73-198.19,298.27-247.05,485.22-565.61,537.09-865.79Z",
    style: {
      fill: "url(#Sfumatura_senza_nome_77)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1488.86-33.46H-8.79v881.14c163.02,8.3,338.13-3.73,517.59-38.83,424.25-82.98,778.02-276.36,980.06-508.08V-33.46Z",
    style: {
      fill: "url(#Sfumatura_senza_nome_109)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M960.79,1033.74h528.99V72.37c-16.48-1.26-32.95-2.54-49.4-3.82-96.96-7.14-194.94-15.67-291.71-21.76,3.22,31.88,6.79,63.7,10.28,95.51,3.33,28.15,6.6,56.35,9.56,84.62,21.29,181.76,21.29,370.61-51.29,542.42-39.91,95.76-96.8,180.99-156.43,264.41Z",
    style: {
      fill: "url(#Sfumatura_senza_nome_120)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1078.98,1033.74h410.8V333.51c-119.53-133.89-270.95-177.07-270.95-177.07,0,0,19.35,36.56,29.03,194.95,9.68,158.4,2.42,260.75-48.38,438.65-20.87,73.1-69.94,163.06-120.49,243.69Z",
    style: {
      fill: "url(#Sfumatura_senza_nome_168)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1438.87,68.55c-96.96-7.14-194.94-15.67-291.71-21.76,3.23,31.88,6.79,63.7,10.28,95.51,3.32,28.15,6.6,56.35,9.55,84.62,12.9,110.12,17.97,222.85,3.84,332.81,126.98-76.73,234.31-164.67,316.52-258.95V72.3c-16.18-1.24-32.34-2.49-48.48-3.75Z",
    style: {
      fill: "url(#Sfumatura_senza_nome_136)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.05,808.85c82.24-16.09,161.82-36.34,238.18-60.2,242.97-232.77,395.87-514.17,441.99-781.06H-7.12v880.21c162.34,8.06,336.6-4.02,515.17-38.95Z",
    style: {
      fill: "url(#Sfumatura_senza_nome_142)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.37-32.41v804.36C823.74,851.74,1028.49,233.02,1086.99-32.41H-6.37Z",
    style: {
      fill: "url(#Sfumatura_senza_nome_149)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-10-32.41v808.13c56.13-8.38,112.52-19.92,168.31-34.72,40.57-10.76,80.83-23.25,120.49-37.49,227.56-81.61,439.24-218.08,565.04-436.18,55.18-95.73,90.93-196.35,115.91-299.74H-10Z",
    style: {
      fill: "url(#Sfumatura_senza_nome_156)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.47,135.75c211-53.4,395.36-68.73,550.63-63.68,9.55-34.98,17.35-69.85,23.34-104.48H-7.12v592.91C112.32,387.35,304.93,213.84,613.47,135.75Z",
    style: {
      fill: "url(#Sfumatura_senza_nome_174)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M792.93,92.72s-61.45,283.69-348.55,359.2c-287.1,75.51-396.55-34.18-396.55-34.18,0,0-64.93-156.6,36.4-280.46,101.33-123.86,708.7-44.56,708.7-44.56Z",
    style: {
      fill: "url(#Sfumatura_senza_nome_168-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.47,135.75c165.42-41.87,314.44-60.32,445.92-63.91,11.37-38.36,20.06-73.65,26.81-104.25H-7.12v592.91C112.32,387.35,304.93,213.84,613.47,135.75Z",
    style: {
      fill: "url(#Sfumatura_senza_nome_174-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.47,135.75c112.03-28.35,216.53-45.96,313.17-55.49,12.51-37.11,23.15-74.7,32.32-112.67H-7.12v592.91C112.32,387.35,304.93,213.84,613.47,135.75Z",
    style: {
      fill: "url(#Sfumatura_senza_nome_181)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.12,555.45c73.14-100.86,162.34-188.5,264.36-257.74,66.75-45.31,138.6-82.26,213.25-111.34,86.67-33.77,177.37-55.68,268.24-73.36,159.69-31.07,323.11-43.66,485.34-32.21,89.51,6.32,178.62,20.2,265.71,42.62v-31.6c-119.46-30.42-242.45-44.62-365.38-45.84-175.17-1.74-350.01,23.54-519.74,67.61-154.26,40.06-300.58,111.15-425.02,214.25-52.02,43.1-99.8,91.61-142.96,144.15-15.21,18.52-29.79,37.59-43.8,57.1v26.36Z",
    style: {
      fill: "url(#Sfumatura_senza_nome_187)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.72-33.63v309.47c35.36-38.28,79.05-78.48,133.06-119.4C408.38-58,904.32,37.04,904.32,37.04l-73.97-70.67H-7.72Z",
    style: {
      fill: "url(#Sfumatura_senza_nome_184)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1247.85,348.96c3.52,57.65,4.8,107.87,2.55,157.02,86.19-59.31,161.31-124.02,223.23-192.24-116.57-120.3-254.81-159.73-254.81-159.73,0,0,19.35,36.55,29.03,194.95Z",
    style: {
      fill: "url(#Sfumatura_senza_nome_203)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813.72,208.97c-248.08,16.93-447.67,193.61-589.2,386.12,210.47-52.39,413.69-163.28,549.57-335.86,28.83-33.11,39.62-50.26,39.62-50.26Z",
    style: {
      fill: "url(#Sfumatura_senza_nome_211)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.78,473.55c36.19-3.91,76.36-11.15,120.81-22.84,158.94-41.81,248.73-147.42,297.21-233.37-163.67,32.34-304.04,133.25-418.02,256.21Z",
    style: {
      fill: "url(#Sfumatura_senza_nome_220)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1490,401.54s-383.8,291.71-436.84,632.2h436.84V401.54Z",
    style: {
      fill: "url(#Sfumatura_senza_nome_228)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1488.83,1033.73S960.92,753.36-5.29,724.04v309.69h1494.12Z",
    style: {
      fill: "url(#Sfumatura_senza_nome_7)",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750-33.74S460.37,405.98-5.29,485.4V-33.74h755.29Z",
    style: {
      fill: "url(#Sfumatura_senza_nome_5)",
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Livello_2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1480,
    height: 1000,
    style: {
      fill: "url(#Sfumatura_senza_nome_25)"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBkgGiallo);
export default __webpack_public_path__ + "static/media/bkg_giallo.239d7365749415dc0105e03deaca60d6.svg";
export { ForwardRef as ReactComponent };